import { useCallback, useState } from 'react';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';

export type NotificationState = {
  readonly open: boolean;
  readonly message: string;
  readonly severity: NotificationSeverity;
};

export type UseNotificationState = {
  readonly notification: NotificationState;
  readonly showNotification: (message: string, severity?: NotificationSeverity) => void;
  readonly hideNotification: () => void;
};

export const useNotification = (): UseNotificationState => {
  const [notification, setNotification] = useState<NotificationState>({
    open: false,
    message: '',
    severity: 'info',
  });

  const showNotification = useCallback(
    (message: string, severity: NotificationSeverity = 'info') => {
      setNotification({ open: true, message, severity });
    },
    [],
  );

  const hideNotification = useCallback(() => {
    setNotification(prev => ({ ...prev, open: false }));
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
  };
};
